import { render, staticRenderFns } from "./Wangeditor.vue?vue&type=template&id=c1df4d38&scoped=true"
import script from "./Wangeditor.vue?vue&type=script&lang=js"
export * from "./Wangeditor.vue?vue&type=script&lang=js"
import style0 from "./Wangeditor.vue?vue&type=style&index=0&id=c1df4d38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1df4d38",
  null
  
)

export default component.exports